<template>
  <div>
    <v-card
      style="
        background-color: transparent;
        border-radius: 15px;
        margin-top: 2vw;
      "
      elevation="1"
    >
      <v-card-text>
        <v-container v-if="loading">
          <v-row dense class="mt-9" alig="center" justify="center">
            <v-progress-circular indeterminate></v-progress-circular>
          </v-row>
        </v-container>
        <v-container v-else>
          <v-row>
            <v-row dense class="course-content__topbar">
              <v-col cols="12" md="7">
                <div class="course-content__title-wrap">
                  <span class="text-h5 font-weight-bold">
                    {{ module.title }} - {{ module.category }}
                  </span>

                  <div class="mt-3 d-flex flex-wrap">
                    <v-chip
                      small
                      outlined
                      color="primary-500"
                      class="mr-2 mb-2"
                    >
                      {{ module.totalLesons || 0 }} material{{
                        module.totalLesons === 1 ? "" : "is"
                      }}
                    </v-chip>

                    <v-chip
                      v-if="isCompleted"
                      small
                      dark
                      color="success"
                      class="mb-2"
                    >
                      Aula concluída
                    </v-chip>
                  </div>
                </div>
              </v-col>

              <v-col
                cols="12"
                md="5"
                class="d-flex justify-end align-start flex-wrap"
              >
                <v-btn plain class="mr-2 mb-2" @click="goBack()">
                  <v-icon>mdi-chevron-left</v-icon>
                  <strong style="text-transform: capitalize" class="texth7">
                    Voltar
                  </strong>
                </v-btn>

                <v-btn
                  v-if="classLink"
                  rounded
                  outlined
                  color="primary-500"
                  class="mr-2 mb-2"
                  @click="openClassLink"
                >
                  <v-icon left>mdi-open-in-new</v-icon>
                  Abrir link da aula
                </v-btn>
              </v-col>
            </v-row>
          </v-row>
          <v-row style="margin-top: 3vw">
            <v-card
              elevation="1"
              class="mx-auto px-auto my-auto py-auto"
              width="100vw"
            >
              <v-card-text>
                <div class="course-section">
                  <div class="course-section__title">Descrição da aula</div>
                  <div class="course-section__body course-section__description">
                    {{ module.description || "Descrição não informada." }}
                  </div>
                </div>

                <div class="course-section">
                  <div class="course-section__title">Palavras chave</div>
                  <div class="course-section__body">
                    <v-expansion-panels v-if="module.keywords?.length">
                      <v-expansion-panel
                        v-for="(item, i) in module.keywords"
                        :key="i"
                      >
                        <v-expansion-panel-header>
                          {{ item.keyword }}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <span class="text-h6">{{ item.description }}</span>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>

                    <v-alert v-else type="info" text class="mb-0">
                      Nenhuma palavra-chave cadastrada para esta aula.
                    </v-alert>
                  </div>
                </div>

                <div class="course-section">
                  <div class="course-section__body">
                    <v-carousel
                      v-if="module.content?.length"
                      v-model="carouselIndex"
                      :cycle="false"
                      height="700"
                      hide-delimiters
                      show-arrows-on-hover
                      class="rounded-lg mt-3"
                    >
                      <v-carousel-item
                        v-for="(item, i) in module.content"
                        :key="i"
                        :class="{
                          'content-item-card': true,
                          'video-item': isVideo(item.type),
                        }"
                      >
                        <div
                          class="d-flex align-center px-4 pt-2 content-header"
                        >
                          <h3 class="text-h6 white--text">{{ item.name }}</h3>
                          <v-spacer></v-spacer>
                          <v-chip dark color="primary-500" class="ma-2">{{
                            getItemTypeLabel(item.type)
                          }}</v-chip>
                          <v-chip dark color="primary-500"
                            >Visualizando:
                            {{ carouselIndex ? carouselIndex + 1 : 1 }} /
                            {{ module.content.length }}</v-chip
                          >
                        </div>

                        <div
                          class="transparent-content-wrapper fill-height pa-4"
                        >
                          <div v-if="isPDF(item.type)" class="fill-height">
                            <iframe
                              :src="`${item.url}#toolbar=0`"
                              width="100%"
                              height="100%"
                              frameborder="0"
                              allowfullscreen
                            >
                            </iframe>
                          </div>

                          <div v-else-if="isPPT(item.type)" class="fill-height">
                            <DocumentViewerIframe :file-url="item.url" />
                          </div>

                          <div
                            v-else-if="isVideo(item.type)"
                            class="d-flex justify-center align-center fill-height"
                          >
                            <video
                              :width="
                                $vuetify.breakpoint.smAndDown ? '100%' : '800'
                              "
                              height="500"
                              controls
                            >
                              <source :src="item.url" type="video/mp4" />
                              Seu navegador não suporta o elemento de vídeo.
                            </video>
                          </div>
                        </div>
                      </v-carousel-item>
                    </v-carousel>

                    <v-alert v-else type="info" text class="mb-0 mt-3">
                      Nenhum material foi disponibilizado para esta aula ainda.
                    </v-alert>
                  </div>
                </div>

                <div class="course-section">
                  <div class="course-section__title">Anotações</div>
                  <div class="course-section__body">
                    <v-row dense>
                      <v-col cols="12" md="4">
                        <v-card class="note-composer pa-4" outlined>
                          <div class="text-h6 font-weight-bold">
                            Novo sticker
                          </div>
                          <div class="note-composer__helper mt-2">
                            Escreva sua anotação e pressione Enter ou o botão
                            abaixo para fixar no mural.
                          </div>

                          <v-textarea
                            label="Digite sua anotação"
                            variant="filled"
                            auto-grow
                            rows="4"
                            class="mt-4"
                            color="primary-500"
                            @keydown.enter.exact.prevent="insertComment"
                            v-model="comment"
                          />

                          <div
                            class="d-flex justify-space-between align-center flex-wrap mt-2"
                          >
                            <span class="text-h7">
                              Anotações feitas: {{ totalComments }}
                            </span>

                            <v-btn
                              rounded
                              color="primary-500"
                              class="white--text mt-2 mt-sm-0"
                              :disabled="!comment.trim()"
                              @click="insertComment"
                            >
                              <v-icon left>mdi-note-plus-outline</v-icon>
                              Criar sticker
                            </v-btn>
                          </div>
                        </v-card>
                      </v-col>

                      <v-col cols="12" md="8">
                        <sticky-notes-board
                          :notes="comments"
                          :module-key="moduleId || $route.params.id"
                        />
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import StickyNotesBoard from "@/components/course/StickyNotesBoard.vue";
import DocumentViewerIframe from "@/components/DocumentViewerIframe.vue";
import pitchCustomerApi from "@/shared/pitchCustomerApi";
import { format } from "date-fns";
export default {
  name: "CourseContentPage",
  components: {
    StickyNotesBoard,
    DocumentViewerIframe,
  },
  async created() {
    await this.loadContent();
  },
  data() {
    return {
      module: {},
      moduleId: "",
      loading: true,
      comments: [],
      totalComments: 0,
      comment: "",
      carouselIndex: 0,
      isCompleted: false,
      completedAt: null,
    };
  },
  computed: {
    classLink() {
      return this.$route.query.classLink || "";
    },
  },
  methods: {
    async loadContent() {
      this.loading = true;

      await pitchCustomerApi
        .getCourseContent(this.$route.params.id)
        .then((res) => {
          this.moduleId = this.$route.params.id;
          this.comments = res.data.notes.notes;
          this.totalComments = res.data.notes.count;
          this.module = res.data.content;
          this.isCompleted = !!res.data.completed;
          this.completedAt = res.data.completedAt;
          this.applyRequestedMaterial();
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    applyRequestedMaterial() {
      const materialId = this.$route.query.material;

      if (!materialId || !Array.isArray(this.module.content)) {
        this.carouselIndex = 0;
        return;
      }

      const selectedIndex = this.module.content.findIndex(
        (item) => item.id === materialId
      );

      this.carouselIndex = selectedIndex >= 0 ? selectedIndex : 0;
    },
    getItemTypeLabel(type) {
      if (this.isPDF(type)) return "PDF";
      if (this.isPPT(type)) return "PPT/Apresentação";
      if (this.isVideo(type)) return "Vídeo";
      return "Conteúdo";
    },
    goBack() {
      this.$router.back();
    },
    openClassLink() {
      if (!this.classLink) {
        return;
      }

      window.open(this.classLink, "_blank");
    },
    googleDocsViewerUrl(url) {
      return `https://docs.google.com/gview?url=${encodeURIComponent(
        url
      )}&embedded=true`;
    },
    insertComment() {
      if (this.comment.trim() === "") return;

      pitchCustomerApi
        .addCourseContentNote(this.moduleId, this.comment)
        .then((res) => {
          this.comments = [...this.comments, res.data.note];
          this.totalComments = this.comments.length;
          this.$root.$emit("display-alert", {
            text: `Comentário adicionado com sucesso!`,
            type: 0,
            timeout: 1500,
          });
        })
        .catch(() => {
          this.$root.$emit("display-alert", {
            text: "Nao foi possivel salvar sua anotação agora.",
            type: 1,
            timeout: 1500,
          });
        });

      this.comment = "";
    },
    formatDate(date) {
      if (date) return format(date, "dd/MM/yyyy HH:mm");
    },
    isPDF(filename) {
      return filename.includes("pdf");
    },
    isVideo(filename) {
      return filename.includes("mp4");
    },
    isPPT(filename) {
      return (
        filename.includes("presentation") ||
        filename.includes("ppt") ||
        filename.includes("pptx") ||
        filename.includes("powerpoint")
      );
    },
  },
  watch: {
    "$route.fullPath"() {
      this.loadContent();
    },
  },
};
</script>

<style lang="css" scoped>
.course-content__topbar {
  width: 100%;
}

.course-content__title-wrap {
  display: flex;
  flex-direction: column;
}

.course-section {
  margin-top: 1.75rem;
  padding: 1.35rem;
  border-radius: 24px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.98) 0%,
    rgba(253, 242, 248, 0.78) 100%
  );
  border: 1px solid rgba(236, 72, 153, 0.12);
}

.course-section:first-child {
  margin-top: 0;
}

.course-section__title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #111827;
}

.course-section__body {
  margin-top: 1rem;
}

.course-section__description {
  color: #374151;
  line-height: 1.7;
  font-size: 1rem;
}

.note-composer {
  border-radius: 24px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.98) 0%,
    rgba(252, 231, 243, 0.72) 100%
  );
  border-color: rgba(236, 72, 153, 0.14);
}

.note-composer__helper {
  color: rgba(31, 41, 55, 0.72);
  line-height: 1.5;
}
</style>
